function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 1.49988C2.84315 1.49988 1.5 2.84302 1.5 4.49988V19.4999C1.5 21.1567 2.84315 22.4999 4.5 22.4999H19.5C21.1569 22.4999 22.5 21.1567 22.5 19.4999V4.49988C22.5 2.84302 21.1569 1.49988 19.5 1.49988H4.5ZM15.6489 11.1708H6.34054C5.88221 11.1708 5.50721 11.5458 5.50721 12.0041C5.50721 12.4625 5.88221 12.8375 6.34054 12.8375H15.6489L11.5822 16.9041C11.4262 17.0598 11.3385 17.2712 11.3385 17.4916C11.3385 17.7121 11.4262 17.9234 11.5822 18.0791C11.9072 18.4041 12.4322 18.4041 12.7572 18.0791L18.2489 12.5875C18.5739 12.2625 18.5739 11.7375 18.2489 11.4125L12.7572 5.9208C12.4322 5.5958 11.9072 5.5958 11.5822 5.9208C11.2572 6.2458 11.2572 6.77913 11.5822 7.10413L15.6489 11.1708Z",
    fill: "#9da3a8"
  }));
};
export default SvgComponent;
//# sourceMappingURL=DeliveryTicket.js.map